import { isEmpty } from 'lodash';

import {
    REQUEST_ALO_CONNECTIONS,
    RECEIVE_ALO_CONNECTIONS,
    FAILURE_ALO_CONNECTIONS,
    REQUEST_ALO_DELETE_CONNECTION,
    SUCCESS_ALO_DELETE_CONNECTION,
    FAILURE_ALO_DELETE_CONNECTION,
    REQUEST_ALO_DELETE_ACCOUNT,
    SUCCESS_ALO_DELETE_ACCOUNT,
    FAILURE_ALO_DELETE_ACCOUNT,
    REQUEST_ALO_REACTIVATE_ACCOUNT,
    SUCCESS_ALO_REACTIVATE_ACCOUNT,
    FAILURE_ALO_REACTIVATE_ACCOUNT
} from './constants';
import { HTTP_METHOD_DELETE, HTTP_METHOD_PUT } from '../../../constants/httpMethod';

import { CALL_API } from '../../../middlewares/api';

const shouldFetchAccountConnections = state => {
    const connections = state.account.accountLinkedOffer.connections;
    const fetching = state.account.accountLinkedOffer.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(connections)) {
        return true;
    } else {
        return false;
    }
};

export function fetchAccountConnectionsIfNeeded(forceRefresh) {
    return {
        [CALL_API]: {
            endpoint: '/account-linked-offer/connections',
            types: [REQUEST_ALO_CONNECTIONS, RECEIVE_ALO_CONNECTIONS, FAILURE_ALO_CONNECTIONS],
            shouldCallAPI: state =>
                !forceRefresh ? shouldFetchAccountConnections(state) : forceRefresh,
            authenticated: true
        }
    };
}

export function deleteConnection(id) {
    return {
        [CALL_API]: {
            method: HTTP_METHOD_DELETE,
            endpoint: `/account-linked-offer/connections/${id}`,
            types: [
                REQUEST_ALO_DELETE_CONNECTION,
                SUCCESS_ALO_DELETE_CONNECTION,
                FAILURE_ALO_DELETE_CONNECTION
            ],
            authenticated: true,
            successCallback: (response, dispatch) => {
                dispatch(fetchAccountConnectionsIfNeeded(true));
            }
        }
    };
}

export function deleteAccount(id) {
    return {
        [CALL_API]: {
            method: HTTP_METHOD_DELETE,
            endpoint: `/account-linked-offer/accounts/${id}`,
            types: [
                REQUEST_ALO_DELETE_ACCOUNT,
                SUCCESS_ALO_DELETE_ACCOUNT,
                FAILURE_ALO_DELETE_ACCOUNT
            ],
            authenticated: true,
            successCallback: (response, dispatch) => {
                dispatch(fetchAccountConnectionsIfNeeded(true));
            }
        }
    };
}

export function reactivateAccount(id) {
    return {
        [CALL_API]: {
            method: HTTP_METHOD_PUT,
            endpoint: `/account-linked-offer/connections/reactivate/${id}`,
            types: [
                REQUEST_ALO_REACTIVATE_ACCOUNT,
                SUCCESS_ALO_REACTIVATE_ACCOUNT,
                FAILURE_ALO_REACTIVATE_ACCOUNT
            ],
            authenticated: true,
            successCallback: (response, dispatch) => {
                dispatch(fetchAccountConnectionsIfNeeded(true));
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/alo/actions.js